<template>
  <v-container fluid>
    <v-card >
      <v-form ref="editForm" @submit.prevent="update">
        <v-toolbar card color="primary" dark dense>
          <v-spacer></v-spacer>
          <v-toolbar-title>{{$t('menu.profile')}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text v-if="currentModel == null" class="text-xs-center">
          <v-progress-circular
            :width="6"
            :size="60"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-card-text>
        <v-card-text v-else>
          <v-container grid-list-md>
            <v-layout wrap >
              <v-flex xs12>
                <v-text-field
                  :label="$t('users.lastname')"
                  v-model="currentModel.lastname"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :label="$t('users.firstname')"
                  v-model="currentModel.firstname"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  readonly
                  :label="$t('users.login')"
                  v-model="currentModel.login"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="usersRoles"
                  item-text="name"
                  item-value="number"
                  v-model="currentModel.role"
                  :label="$t('users.role')"
                  :rules="[rules.required]"
                  readonly
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="newPassword"
                  :append-icon="show ? 'visibility_off' : 'visibility'"
                  :rules="[rules.min]"
                  :type="show ? 'text' : 'password'"
                  :label="$t('users.password')"
                  :hint="$t('users.passwordRule')"
                  counter
                  @click:append="show = !show"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="newPassword2"
                  :append-icon="show ? 'visibility_off' : 'visibility'"
                  :rules="[rules.min, rules.same]"
                  :type="show ? 'text' : 'password'"
                  :label="$t('users.confirmation')"
                  :hint="$t('users.passwordRule')"
                  counter
                  @click:append="show = !show"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="langsList"
                  v-model="currentModel.lang"
                  :label="$t('users.lang')"
                  :rules="[rules.required]"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="usersLoading"
            submit
            flat
            type="submit"
          >{{$t('general.update')}}</v-btn>
          <v-btn
            color="secondary"
            :disabled="usersLoading"
            submit
            flat
            @click.native="getModel"
          >{{$t('general.cancel')}}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {

  name: "UserProfile",

  components: {},

  data() {
    return {
      show: false,
      rules: {
        required: value => !!value || this.$t('fields.required'),
        min: v => {
          if (v !== undefined && v.length !== 0) {
            return v.length >= 8 || this.$t('users.passwordRule')
          } else {
            return true;
          }
        },
        same: v =>
          v === this.newPassword || this.$t('users.passwordRule')
      },
      currentModel: {},
      newPassword: "",
      newPassword2: ""
    };
  },

  mounted() {
    this.getModel()
  },

  methods: {

    async getModel() {
      this.currentModel = null
      this.currentModel = Object.assign({}, this.user);
      this.currentModel.password = "";
    },

    setLogin() {
      if (this.currentModel.firstname !== undefined) {
        this.currentModel.login = (
          this.currentModel.firstname.charAt(0) + this.currentModel.lastname
        ).toLowerCase();
      }
    },

    async update() {
      if (this.$refs.editForm.validate()) {
        this.currentModel.password = this.newPassword;
        if (
          await this.updateMyAccount({
            id: this.user._id,
            data: this.currentModel
          })
        ) {
          this.$emit("closedialog");
        }
      }
    },

    ...mapActions('users', {
      getOneUser: 'getOne',
      updateMyAccount: 'updateMyAccount'
    })

  },
  computed: {
    ...mapGetters('users', {
      usersRoles: 'roles',
      usersLoading: 'loading'
    }),

    ...mapGetters('user', {
      user: 'current'
    }),

    ...mapGetters('interfaceSettings', {
      langsList: 'adminLangs'
    })

  },

  watch: {

    "currentModel.firstname"(val) {
      if (val !== undefined) {
        this.setLogin();
      }
    },

    "currentModel.lastname"(val) {
      if (val !== undefined) {
        this.setLogin();
      }
    }

  }
};
</script>
